import { useParams } from "react-router-dom";
import { useState, useContext, useEffect, useLayoutEffect } from "react";
import { cards, specialCards, color } from "../../Data/cards";
import Card from "../Card/card";
import styles from "../game.module.css";
import { MyContext } from "../../utils/utils";
import { db } from "../../utils/firebase";
import { onValue, ref, remove, set, update } from "firebase/database";
import { Button, InputNumber, Form, notification, Divider } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const MyCard = () => {
  const { key } = useParams();

  const { currentUser } = useContext(MyContext);
  const [currentCard, setCurrentCard] = useState(null);
  const [joiners, setJoiners] = useState(null);
  const [currentJoiner, setCurrentJoiner] = useState(null);
  const [cardSelected, setCardSelected] = useState(false);
  const [leftCards, setLeftCards] = useState([]);
  const [direction, setDirection] = useState("CW");

  const [myCards, setMyCards] = useState(null);
  const [mode, setMode] = useState(null);

  const [middleJoin, setMiddleJoin] = useState(null);

  useEffect(() => {
    if (currentUser == null) return;

    onValue(ref(db, "rooms/" + key + "/joiner"), (snapshot) => {
      const val = snapshot.val();
      setJoiners(Object.keys(val));
    });

    onValue(
      ref(db, "rooms/" + key + "/joiner/" + currentUser.uid + "/cards"),
      (snapshot) => {
        const val = snapshot.val();
        if (val) {
          setMyCards(val);
        } else if (val == null) {
          setMyCards(null);
        }
      }
    );

    onValue(ref(db, "rooms/" + key + "/currentJoiner"), (snapshot) => {
      const val = snapshot.val();
      if (val) {
        setCurrentJoiner(val);
        if (val != currentUser.uid) {
          setSelectIdx(null);
          setCardSelected(false);
        }
      }
    });

    onValue(ref(db, "rooms/" + key + "/selecting"), (snapshot) => {
      const val = snapshot.val();
      setCardSelected(val);
      setSelectIdx(null);
    });

    onValue(ref(db, "rooms/" + key + "/currentCard"), (snapshot) => {
      const val = snapshot.val();
      setCurrentCard(val);
      setSelectIdx(null);
    });

    onValue(
      ref(db, "rooms/" + key + "/joiner/" + currentUser.uid + "/middleJoin"),
      (snapshot) => {
        const val = snapshot.val();
        setMiddleJoin(val);
      }
    );

    onValue(ref(db, "rooms/" + key + "/leftCards"), (snapshot) => {
      const val = snapshot.val();
      setLeftCards(val);
    });

    onValue(ref(db, "rooms/" + key + "/direction"), (snapshot) => {
      const val = snapshot.val();
      setDirection(val);
    });

    onValue(ref(db, "rooms/" + key + "/mode"), (snapshot) => {
      const val = snapshot.val();
      setMode(val);
    });
  }, [db, currentUser]);

  const [selectIdx, setSelectIdx] = useState(null);

  const checkCondition = (idx, usedCard = null) => {
    var card = myCards[idx];
    if (usedCard) {
      return true;
    }

    if (mode.card) {
      if (
        card.distance == currentCard.distance ||
        currentCard.color == color.white ||
        currentCard.color == color.black ||
        card.color == color.black ||
        card.color == color.white ||
        card.color == currentCard.color
      ) {
        return true;
      }
      return false;
    }
    return true;
  };

  const [api, contextHolder] = notification.useNotification();

  const onClickCard = (event, idx, special = false) => {
    if (!special && (usedCard != null || changeColor)) return;

    if (currentJoiner == currentUser.uid && !cardSelected) {
      if (checkCondition(idx, usedCard)) {
        setSelectIdx(idx);
      } else {
        api.info({
          message: "해당 카드를 선택할 수 없습니다",
          description: "거리 또는 색상이 같은 카드 혹은 특수 카드를 선택하세요",
          icon: <ExclamationCircleOutlined style={{ color: color.yellow }} />,
          placement: "bottomRight",
          duration: 2,
          key: "updateable",
        });
      }
    } else {
      setSelectIdx(null);
    }
  };

  const onFinish = (value) => {
    var num = value.InputNumber;

    if (num == null) {
      num = 3;
    }

    onGetCard(num);

    remove(
      ref(db, "rooms/" + key + "/joiner/" + currentUser.uid + "/middleJoin")
    );
  };

  const onGetCard = (value) => {
    const cards = getCards(value);

    var temp = [];
    if (myCards != null) temp = myCards.slice();
    for (var idx in cards) {
      temp.push(cards[idx]);
    }
    const cardsRef = ref(
      db,
      "rooms/" + key + "/joiner/" + currentUser.uid + "/cards"
    );
    set(cardsRef, temp);
  };

  const getRandom = (min, max, num) => {
    var arr = [];
    while (arr.length < num) {
      var r = parseInt(Math.random() * (max - min) + min);
      if (arr.indexOf(r) === -1) arr.push(r);
    }
    return arr;
  };

  const getCards = (num = 1) => {
    const arr = getRandom(0, leftCards.length, num);
    const newLeftCards = leftCards.filter(
      (value, index) => !arr.includes(index)
    );
    set(ref(db, "rooms/" + key + "/leftCards"), newLeftCards);
    return leftCards.filter((value, index) => arr.includes(index));
  };

  const onClickGetCard = () => {
    if (leftCards != null) onGetCard(1);

    const currentIdx = joiners.indexOf(currentUser.uid);
    var nextIdx;
    if (direction == "CCW") {
      nextIdx = currentIdx + 1;
      if (nextIdx >= joiners.length) {
        nextIdx = 0;
      }
    } else if (direction == "CW") {
      nextIdx = currentIdx - 1;
      if (nextIdx < 0) {
        nextIdx = joiners.length - 1;
      }
    }

    set(ref(db, "rooms/" + key + "/selecting"), false);
    set(ref(db, "rooms/" + key + "/currentJoiner"), joiners[nextIdx]);
  };

  // 특수 카드 (재활용, 색바꾸기)
  const colorCard = [color.red, color.yellow, color.green, color.blue].map(
    (value) => ({
      color: value,
      fontColor: color.black,
      name: "색바꾸기",
    })
  );
  const [usedCard, setUsedCard] = useState(null);
  const [changeColor, setChangeColor] = useState(false);
  useEffect(() => {
    if (currentCard && currentCard.name == "재활용") {
      onValue(
        ref(db, "rooms/" + key + "/usedCard"),
        (snapshot) => {
          const val = snapshot.val();
          if (currentJoiner == currentUser.uid) {
            setUsedCard(Object.values(val));
          }
          setSelectIdx(null);
        },
        {
          onlyOnce: true,
        }
      );
    } else {
      setUsedCard(null);
    }

    if (
      currentCard &&
      currentCard.name == "색바꾸기" &&
      currentCard.color == "#000000" &&
      currentUser.uid == currentJoiner
    ) {
      setChangeColor(true);
      setSelectIdx(null);
    } else {
      setChangeColor(false);
    }
  }, [currentCard]);

  useEffect(() => {}, [selectIdx]);

  return (
    <div className={styles.myCard}>
      {contextHolder}

      {middleJoin ? (
        <>
          <p>가져올 카드 개수를 선택하세요</p>
          <Form
            layout="inline"
            onFinish={onFinish}
            style={{ justifyContent: "center" }}
          >
            <Form.Item name="InputNumber">
              <InputNumber
                id="inputNumber"
                size="large"
                min={1}
                max={9}
                defaultValue={3}
                value={3}
                addonAfter="개"
                style={{ width: "80px", fontSize: "20px", marginRight: "10px" }}
              />
            </Form.Item>
            <Form.Item>
              <Button
                shape="round"
                type="dashed"
                size="large"
                style={{ fontSize: "20px" }}
                htmlType="submit"
              >
                {" "}
                가져오기
              </Button>
            </Form.Item>
          </Form>
        </>
      ) : (
        <>
          <div className={styles.currentJoiner}>
            {currentUser &&
              currentUser.uid == currentJoiner &&
              (cardSelected ? (
                <p>질문할 사람을 클릭하여 선택해주세요.</p>
              ) : usedCard ? (
                <div className={styles.recycleBoard}>
                  <p>원하는 카드를 선택하세요.</p>
                  <div className={styles.recycle}>
                    {usedCard.map((value, index) => {
                      return (
                        <div
                          className={styles.cards}
                          style={{ transform: `scale(0.9)` }}
                          onClick={(e) => onClickCard(e, index, true)}
                        >
                          <Card
                            name={value.name}
                            distance={value.distance}
                            color={value.color}
                            fontColor={value.fontColor}
                            select={index == selectIdx}
                            index={key}
                            setSelectIdx={setSelectIdx}
                            setCardSelected={setCardSelected}
                            mode={mode}
                          />
                        </div>
                      );
                    })}
                  </div>

                  <Divider />
                </div>
              ) : changeColor ? (
                <div className={styles.changeColorBoard}>
                  <p>원하는 카드를 선택하세요.</p>
                  <div className={styles.changeColor}>
                    {colorCard.map((value, index) => {
                      return (
                        <div
                          className={styles.cards}
                          style={{ transform: `scale(0.9)` }}
                          onClick={(e) => onClickCard(e, index, true)}
                        >
                          <Card
                            name={value.name}
                            distance={value.distance}
                            color={value.color}
                            fontColor={value.fontColor}
                            select={index == selectIdx}
                            index={key}
                            setSelectIdx={setSelectIdx}
                            setCardSelected={setCardSelected}
                            mode={mode}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <Divider />
                </div>
              ) : (
                <>
                  {leftCards ? (
                    <div>
                      선택할 카드가 없다면
                      <Button
                        shape="round"
                        size="large"
                        type="dashed"
                        style={{ fontSize: "20px", marginLeft: "10px" }}
                        onClick={() => onClickGetCard()}
                      >
                        카드 가져오기
                      </Button>
                    </div>
                  ) : (
                    <div>
                      선택할 카드가 없다면
                      <Button
                        shape="round"
                        size="large"
                        type="dashed"
                        style={{ fontSize: "20px", marginLeft: "10px" }}
                        onClick={() => onClickGetCard()}
                      >
                        넘어가기
                      </Button>
                    </div>
                  )}
                  {myCards && (
                    <p style={{ marginBottom: "0px" }}>
                      원하는 카드를 선택하세요.
                    </p>
                  )}
                </>
              ))}
          </div>
          {myCards && (
            <div className={styles.cardBoard}>
              {Object.keys(myCards).map((key, index) => {
                const value = myCards[key];
                const idx = index - (Object.keys(myCards).length - 1) / 2;
                const angle = (10 * idx * Math.PI) / 180;
                const left = `calc(50% - 75px + ${120 * Math.sin(angle)}px)`;
                // const top = `calc(50% - ${50 * Math.cos(angle)}%)`;
                // const rotate = idx * (10 - size[0] / 200);
                const top = `calc(50% - 100px)`;
                const rotate = 0;
                return (
                  <div
                    className={styles.cards}
                    style={{
                      //   position: "absolute",
                      //   left: left,
                      //   top: top,
                      transform: `scale(0.9)`,
                      //   translate(${left}, ${top})`,
                    }}
                    onClick={(e) => onClickCard(e, index)}
                  >
                    <Card
                      name={value.name}
                      distance={value.distance}
                      color={value.color}
                      fontColor={value.fontColor}
                      select={
                        !cardSelected &&
                        currentJoiner == currentUser.uid &&
                        index == selectIdx &&
                        usedCard == null &&
                        changeColor == false
                      }
                      index={key}
                      setSelectIdx={setSelectIdx}
                      setCardSelected={setCardSelected}
                      mode={mode}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MyCard;
